import { syntaxHighlighting } from '@codemirror/language';
import type { Extension } from '@codemirror/state';
import { tooltips } from '@codemirror/view';

import { EscapedCharacterDecorationPlugin } from '../decorations/escaped-characters.js';
import { FilterErrorDecorationPlugin } from '../decorations/filter-errors.js';
import { FilterExistsDecorationPlugin } from '../decorations/filter-exists-operator.js';
import { FilterKeyDecorationPlugin } from '../decorations/filter-keys.js';
import { FilterSearchDecorationPlugin } from '../decorations/filter-search.js';
import { FilterStatementDeleteWidgetPlugin } from '../decorations/filter-statements-delete-widget.js';
import { FilterStatementDecorationPlugin } from '../decorations/filter-statements.js';
import { FilterValueDecorationPlugin } from '../decorations/filter-values.js';
import { FilterVariableDecorationPlugin } from '../decorations/filter-variable.js';
import { filterFieldHighlighter } from '../decorations/highlight.js';

export const FilterFieldSyntaxHighlightingExtension: Extension = (() => [
  // Enable highlighting using the defined highlighter.
  // This adds the spans and classes used to style the different parts of a filter.
  syntaxHighlighting(filterFieldHighlighter),
  // Add decoration plugins for wrapping filter groups, statements, keys, and values
  // in additional spans for styling. This is not possible using only a highlighter
  // since the highlighter can only wrap nodes that have no more nesting levels.
  EscapedCharacterDecorationPlugin,
  FilterErrorDecorationPlugin,
  FilterKeyDecorationPlugin,
  FilterSearchDecorationPlugin,
  FilterVariableDecorationPlugin,
  FilterValueDecorationPlugin,
  FilterExistsDecorationPlugin,
  FilterStatementDeleteWidgetPlugin,
  FilterStatementDecorationPlugin,

  tooltips({ parent: document.body }),
])();
